<smrts-dialog title="Correspondências com diferença" [hasFootnote]="true" fixedHeight="600px">

  @if (correspondencias.length === 0) {
    <p class="lista-vazia">Nenhuma correspondência com diferença.</p>
  }

  @if (correspondencias.length > 0) {
    <p-table [value]="correspondencias" responsiveLayout="scroll" sortMode="multiple">
      <ng-template pTemplate="header">
        <tr>
          <th pSortableColumn="somaBanco">Soma do banco<p-sortIcon field="somaBanco" /></th>
          <th pSortableColumn="diferenca">Diferença<p-sortIcon field="diferenca" /></th>
          <th pSortableColumn="qtdLancamentosBanco">Lançamentos banco<p-sortIcon field="qtdLancamentosBanco" /></th>
          <th pSortableColumn="qtdLancamentosCaixa">Lançamentos caixa<p-sortIcon field="qtdLancamentosCaixa" /></th>
          <th></th>
        </tr>
      </ng-template>
      <ng-template #body let-item>
        <tr>
          <td>{{ item.somaBanco | currency:'BRL' }}</td>
          <td [ngClass]="{'red-text': item.diferenca < 0 }">{{ item.diferenca | currency:'BRL' }}</td>
          <td>{{ item.qtdLancamentosBanco }}</td>
          <td>{{ item.qtdLancamentosCaixa }}</td>
          <td>
            <button mat-icon-button class="visibility-btn" matTooltip="Ver correspondência" (click)="visualizarClick(item)">
              <mat-icon>visibility</mat-icon>
            </button>
          </td>
        </tr>
      </ng-template>
    </p-table>
  }

  <div footnote class="inline-element footnote">
    <button class="white-text-button" mat-flat-button [mat-dialog-close]="true">
      Fechar
    </button>
  </div>
</smrts-dialog>
